<script setup lang="ts">
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import { onBeforeMount, reactive, ref } from "vue";
import axios from "./../../utils/axios";
import Navbar from "../home/repeat/Navbar.vue";
const router = useRouter();
// 使用 ref 创建 showModal 变量，并初始化为 false
const showModal = ref(false);

// 定义进入招聘活动页面时记录滚动位置的方法
const recordScrollPosition = () => {
  sessionStorage.setItem("scrollPosition", String(window.scrollY));
};
// 定义打开模态框的方法
const openModal = (desc) => {
  document.body.style.overflow = "hidden";
  showModal.value = true;
  state.jobDesc = desc;
  state.jobDescEn = desc;
  // 进入招聘活动页面时记录滚动位置
  recordScrollPosition();
};
// 定义关闭模态框的方法
const closeModal = () => {
  state.jobDesc = "";
  document.body.style.overflow = "";
  showModal.value = false;
  const scrollPosition = sessionStorage.getItem("scrollPosition");
  if (scrollPosition) {
    window.scrollTo(0, parseInt(scrollPosition));
  }
};
// 数据
const state = reactive({
  HrList: [],
  RecruitList: [],
  jobDesc: "",
  jobDescEn: "",
});
onBeforeMount(() => {
  getRecruitList();
  getHrList();
});
//获取hr列表
const getHrList = () => {
  axios.get("framework/hr/list").then((res) => {
    state.HrList = res;
  });
};

const getRecruitList = () => {
  axios.get("framework/recruit/list").then((res) => {
    state.RecruitList = res;
  });
};
</script>

<template>
  <div class="talentPlan">
    <div class="main">
      <div class="kong">
        <Header> </Header>
      </div>
      <div class="image">
        <div class="image_box">
          <img src="./../../../public/zhaopin.jpg" alt="" />
        </div>
      </div>
      <div class="title">
        <div class="title_li">
          <div class="title_lis">
            <a class="no" href="/">{{ $t("system.home.menu.home") }}</a>
            <text>></text>
            <a class="th">{{ $t("system.home.menu.talentPlan") }}</a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="con_box">
          <div class="wrap">
            <div class="wrap_top">
              <div class="top_title">{{ $t("system.talentPlan.title") }}</div>
              <div class="text">
                <p>
                  {{ $t("system.talentPlan.p_1") }}
                </p>
                <p>
                  {{ $t("system.talentPlan.p_2") }}
                </p>
                <p>
                  {{ $t("system.talentPlan.p_3") }}
                </p>
                <p>
                  {{ $t("system.talentPlan.p_4") }}
                </p>
              </div>
            </div>
            <div class="zhi_wei">
              <div class="z_title">{{ $t("system.talentPlan.title_2") }}</div>
              <div class="table">
                <!--todo 职位-->
                <table>
                  <thead>
                    <tr>
                      <th>
                        {{ $t("system.talentPlan.th_1") }}
                      </th>
                      <th>
                        {{ $t("system.talentPlan.th_2") }}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="t_o"
                      v-for="item in state.RecruitList"
                      v-if="$i18n.locale === 'zh-cn'"
                    >
                      <td>{{ item.rname }}</td>
                      <td>{{ item.workplace }}</td>
                      <td>
                        <a
                          href="javascript:;"
                          @click="openModal(`${item.jobDesc}`)"
                          >{{ $t("system.talentPlan.can") }}</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 模态框 -->
              <div v-if="showModal" class="modal-overlay" @click="closeModal">
                <div class="modal-container">
                  <div class="modal-close" @click="closeModal">
                    <van-icon class="modal_icon" name="cross" />
                  </div>
                  <!-- 模态框内容 -->
                  <div class="modal-content" v-html="state.jobDescEn"></div>
                </div>
              </div>
            </div>
            <div class="lian_xi">
              <div
                class="f_s"
                v-for="item in state.HrList"
                :key="item.id"
              >
                <div class="xi_t">{{ item.place }}</div>
                <div class="xi_to">
                  <div>
                    <strong>{{ $t("system.talentPlan.hr") }}</strong>
                    {{ item.mail }}
                  </div>
                  <div>
                    <strong>{{ $t("system.talentPlan.phone") }}</strong>
                    {{ item.tel }} {{ item.phone }} （{{ item.name }}）
                  </div>
                  <div>
                    <strong>{{ $t("system.talentPlan.dizhi") }}</strong>
                    {{ item.workplace }}
                  </div>
                </div>
              </div>
              <div class="xi_fot">
                <b>{{ $t("system.talentPlan.fot_b") }}</b>
                {{ $t("system.talentPlan.fot_d") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
  </div>
</template>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.main {
  width: 100%;
  height: auto;
}

.kong {
  max-width: 1200px;
  height: 120px;
}

.image {
  position: relative;
  width: 100%;
  height: 430px;
}

.image_box {
  padding-top: 26.46%;
  min-height: 200px;
  display: block;
  position: relative;
  overflow: hidden;
  height: 0;
}

.image_box img {
  height: 430px;
  display: block;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  -webkit-transition: all 0.6s linear;
  transition: all 0.6s linear;
}

.title {
  width: 100%;
  height: auto;
  padding: 30px 0;
}

.title_li {
  width: 1200px;
  height: 100%;
  padding: 0 15px;
  margin: 0 auto;
}

.title_lis {
  font-size: 18px;
  margin: 0 -8px;
}

.title_lis a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}

.content {
  width: 100%;
  height: auto;
  padding-bottom: 60px;
}

.con_box {
  width: 1200px;
  height: auto;
  padding: 0 15px;
  margin: 0 auto;
}

.wrap {
  width: 760px;
  height: 100%;
}

.wrap_top {
  width: 100%;
  height: auto;
}

.top_title {
  width: 100%;
  height: 26px;
  line-height: 26px;
  font-size: 24px;
  font-weight: 500;
  color: #762d28;
  margin-bottom: 35px;
}

.text {
  display: flex;
  font-size: 18px;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  text-align: justify;
  line-height: 1.77;
  height: auto;
}

p {
  margin: 0;
  padding-top: 40px;
}

.zhi_wei {
  width: 100%;
  height: auto;
  margin-top: 60px;
  padding-top: 50px;
  border-top: 2px solid #b9bab9;
}

.z_title {
  font-size: 24px;
  height: 26px;
  font-weight: 500;
  color: #762d28;
  margin-bottom: 35px;
}

.table {
  width: 100%;
  height: 416px;
}

.lian_xi {
  display: flex;
  flex-direction: column;

  width: 100%;
  height: auto;
}

.xi_t {
  height: 26px;
  font-size: 24px;
  font-weight: 600;
  color: #3e3a39;
  margin-bottom: 15px;
}

.xi_t {
  margin-top: 60px;
}

.xi_to {
  display: flex;
  flex-direction: column;
  text-align: justify;
  font-size: 18px;
  justify-content: space-between;
  width: 100%;
  line-height: 2;
  height: 108px;
}

.xi_fot {
  font-size: 18px;
  padding-top: 60px;
}

table {
  width: 100%;
}

.t_o {
  width: 100%;
  font-size: 18px;
  height: 71px;
  text-align: center;
  color: #696b71;
  border-bottom: 2px solid red;
}

.t_o {
  background: #f0f0f0;
}

thead {
  height: 57px;
  font-weight: 500;
  font-size: 18px;
  color: #3e3a39;
  border-bottom: 2px solid #b9bab9;
}

tbody a {
  color: #762d28 !important;
  text-decoration: underline;
  white-space: nowrap;
}

/* 模态框覆盖层 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 1);
  /* 半透明黑色 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

/* 模态框容器 */
.modal-container {
  width: 80%;
  height: 60%;
  padding: 0;
  position: relative;
  background-color: #f0f0f0;
}

/* 模态框关闭按钮 */
.modal-close {
  position: absolute;
  top: 20px;
  right: 30px;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 45px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  padding: 0;
  cursor: pointer;
}

.modal_icon {
  font-size: 24px;
  color: #fff;
}

/* 模态框内容样式 */
.modal-content {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  overflow-y: auto;
  background-color: #ffffff;
}
</style>
